(() => {
  const enhanceGalleryImages = () => {
    document.querySelectorAll('.shem-editorial-section .shem-media-card img, .shem-editorial-section .shem-watch-view img').forEach((img) => {
      if (img.closest('a.shem-media-open')) return;
      const src = img.currentSrc || img.src;
      if (!src) return;
      const link = document.createElement('a');
      link.className = 'shem-media-open';
      link.href = src;
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', `Open ${img.alt || 'afbeelding'} op volledige grootte`);
      img.parentNode.insertBefore(link, img);
      link.appendChild(img);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceGalleryImages, { once: true });
  } else {
    enhanceGalleryImages();
  }
})();
